// extracted by mini-css-extract-plugin
export default {"selectDropdown":"styles_selectDropdown__kMm9Q","sider":"styles_sider__VbZ0G"};